import { createSlice } from '@reduxjs/toolkit'

// raundとして保持するべき、グローバル変数を保持する
type initialRaundProps = {
  // 未獲得の特典の数
  newRewardsCount: number
}

const initialState: initialRaundProps = {
  newRewardsCount: 0,
}

const raundReducer = createSlice({
  name: 'raundGlobalState',
  initialState: initialState,
  reducers: {
    sliceNewRewardsCount(state, action) {
      state.newRewardsCount = action.payload
    },
  },
})

export const { sliceNewRewardsCount } = raundReducer.actions

export default raundReducer.reducer
